import {IBizSign, IBusiness} from "@/views/editor/service/business";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {IInput, IInputTypeCheckbox, IInputTypeInput, IInputTypeRadio} from "@/views/editor/service/types";
import {ASign} from "@/views/editor/service/sign/sign";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {reactive} from "vue";
import {Rule} from "ant-design-vue/es/form";
import {IFormState} from "@/lib/types";
import {Drag} from "@/lib/drag";

export interface ISignMeta {
    inputs: IInput[]
    auto_phone_number: {
        enable: boolean
    }
}


export default class Sign extends ASign implements IBizSign {
    readonly opt: ISignMeta
    active = reactive({
        rules: {} as Record<string, Rule[]>,
        item: {
            state: {} as IFormState,
            rules: {} as Record<string, Rule[]>,
            input: {} as IInput,
            drag: new Drag()
        },
    })
    readonly typeName: { [key: string]: string } = {
        'input': '文本项',
        'radio': '单选项',
        'checkbox': '多选项',
        'name': '姓名项',
        'phone_number': '手机号',
        'gender': '性别',
    }

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
        this.opt = this.meta.setting as ISignMeta
    }

    subs(): CheckboxOptionType[] {
        return []
    }

    resetMeta(): IBusiness {
        const opt: ISignMeta = {
            auto_phone_number: {enable: false},
            inputs: []
        }
        Object.assign(this.opt, opt)
        return this;
    }

    set(origin: string, inputs: IInput[]): void {
        if (this.opt.inputs.some(x => x.origin === origin)) {
            const l = this.opt.inputs.filter(x => x.origin !== origin);
            if (inputs.length > 0) l.push(...inputs)
            this.opt.inputs = l
        } else if (inputs.length > 0) this.opt.inputs.push(...inputs)
    }

    desc(input: IInput): string {
        switch (input.type) {
            case 'input':
                return `填写${({'number': '数字', 'text': '文字', 'date': '日期'} as {
                    [key: string]: string
                })[(input.config as IInputTypeInput).type]}`
            case 'checkbox': {
                const cfg = input.config as IInputTypeCheckbox;
                return `${cfg.items.length}选${cfg.max == cfg.min ? cfg.max : cfg.min + '/' + cfg.max}：${cfg.items.join('，')}`
            }
            case 'radio': {
                const cfg = input.config as IInputTypeRadio;
                return cfg.items.join('，')
            }
            case 'phone_number':
                return ''
            case 'name':
                return ''
            case 'gender':
                return ''
            default:
                return ''
        }
    }

}